<template>
  <div class="empty-list">
    <div>
      {{ i18n.t(emptyMessageKey) }}
    </div>
    <create-new-event-button v-if="showNewEventButton" class="action-button" size="lg" />
    <create-new-group-button v-if="showNewGroupButton" class="action-button" size="lg" />
  </div>
</template>

<script>
import CreateNewEventButton from './create-new-event-button'
import CreateNewGroupButton from './create-new-group-button'
import { mapState } from 'vuex'

export default {
  components: { CreateNewEventButton, CreateNewGroupButton },

  props: {
    typesIncluded: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapState(['eventCreationAllowed', 'groupCreationAllowed']),

    emptyMessageKey() {
      if (this.typesIncluded.includes('event') && this.typesIncluded.includes('group')) {
        return 'public.local.no_events_or_local_chapters'
      }
      else if (this.typesIncluded.includes('event')) {
        return 'local_chapters.upcoming_events.no_upcoming_events'
      }
      else if (this.typesIncluded.includes('group')) {
        return 'public.local.no_local_chapters'
      }
      else return 'public.local.nothing_selected'
    },

    showNewEventButton() {
      return this.typesIncluded.includes('event') && this.eventCreationAllowed
    },

    showNewGroupButton() {
      return this.typesIncluded.includes('group') && this.groupCreationAllowed
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-list {
  padding: 20px;
}

.action-button {
  margin-top: 30px;
  width: 100%;
  border-radius: 0;
}
</style>
